<div class="card stat-card" [ngStyle]="{ 'background-color': data.bgColor }">
  <div class="card-content">
    <div class="card-title" [innerHTML]="formattedTitle"></div>
    <div class="card-value-or-error">
      <div *ngIf="!hasError" class="card-value">{{ stat }}</div>
      <mat-icon *ngIf="hasError" class="stat-error-icon">error_outline</mat-icon>
    </div>
  </div>
</div>
